<template>
    <div class="row">
        <div
            v-if="previewImage"
            class="imagePreviewWrapper"
            :style="{ 'background-image': `url(${previewImage})` }"
            @click="selectImage">
        </div>
        <div
            v-else>
            <img @click="selectImage" class="imagePreviewWrapper" :src="require('../../../assets/subir.png')" alt="">
        </div>
        

        <form v-on:submit.prevent>
            <input
                id="photo"
                ref="fileInput"
                type="file"
                @input="pickFile"
                @change="changeFiles"
                >

        
             <div class="form-floating my-3">
                <input v-model="name_photo" type="text" class="form-control" id="floatingInputGroup2" placeholder="nombre" required>
                <label for="floatingInputGroup2">Nombre de foto</label>
            </div>


            <button type="submit" class="btn btn-primary" @click="createPhoto()">Subir Foto</button>

        </form>
    </div>
</template>
<script>
import { useToast } from "vue-toastification";
import {ref} from 'vue'
import axios from "axios";

export default {
    name:'previewComponent',
    props:['photo','user_id','url'],
    emits:['escucharHijo'],
    setup(props,{emit}){
        const toast = useToast();
        const name_photo = ref('')
        const new_image = ref('')
        const fileInput = ref(null)
        const file = ref([])
        const previewImage = ref(props.photo)
        
        const selectImage = () =>{
            fileInput.value.click()
        }
        const pickFile =()=> {
            let input = fileInput.value
            let file = input.files
            if (file && file[0]) {
                let reader = new FileReader
                reader.onload = e => {
                    previewImage.value = e.target.result
                }
                reader.readAsDataURL(file[0])
                emit('input', file[0])
            }
        }
        const clearInputs=()=>{
            fileInput.value = '';
            name_photo.value = '';
            previewImage.value = '';
        }
        const createPhoto = () => {
            let url = props.url+'/api/save-photo'
            axios.post(url , {
                name: name_photo.value,
                photo: new_image.value,
            }).then(response => {
                /*this.getPhotos();*/
                enviarPadre();
                clearInputs()
                toast.success(response+'subido')
            }).catch(error =>{
                toast.error('error'+error);
            });
        }

        const enviarPadre =()=>{
            emit('escucharHijo',previewImage.value)
        }

        const changeFiles = (e) =>{
                //https://stackoverflow.com/questions/43708127/javascript-get-the-filename-and-extension-from-input-type-file
                let name = e.target.files[0].name;
                let lastDot = name.lastIndexOf('.');
                let fileName = name.substring(0, lastDot);
                name_photo.value = fileName;
                var fileReader = new FileReader()
                fileReader.readAsDataURL(e.target.files[0])
                fileReader.onload = (e) => {
                    new_image.value  = e.target.result
                }
                /*console.log(this.$refs.fileInput.files);*/
            }



    return{
        changeFiles,
        enviarPadre,
        fileInput,
        previewImage,
        createPhoto,
        clearInputs,
        pickFile,
        selectImage,
        toast,
        name_photo,
        new_image,
        file
        }
    }
}


    


</script>